/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LegalFormProvider = {
    Pappers: 'PAPPERS',
    NorthData: 'NORTH_DATA'
} as const;
export type LegalFormProvider = typeof LegalFormProvider[keyof typeof LegalFormProvider];


export function instanceOfLegalFormProvider(value: any): boolean {
    for (const key in LegalFormProvider) {
        if (Object.prototype.hasOwnProperty.call(LegalFormProvider, key)) {
            // @ts-ignore
            if (LegalFormProvider[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LegalFormProviderFromJSON(json: any): LegalFormProvider {
    return LegalFormProviderFromJSONTyped(json, false);
}

export function LegalFormProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalFormProvider {
    return json as LegalFormProvider;
}

export function LegalFormProviderToJSON(value?: LegalFormProvider | null): any {
    return value as any;
}

